import _slicedToArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import './CategoriesSiblings.css';
import React from 'react';
import { get } from '../../utils';
// import { Link } from 'react-router-dom';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import { injectImageResolution } from '../../utils';
import { commonStyles, ltrStyles, rtlStyles } from '../47_CategoriesChildren/CategoriesChildren';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import LazyPicture from '../atoms/LazyPicture';
import { ReactComponent as ChevronRight } from '../../resources/icons/IconChevronRightLight.svg';
import { ReactComponent as ChevronLeft } from '../../resources/icons/IconChevronLeftLight.svg';
import { tealiumClickFunc, tealiumMergeClickData } from '../../utils/tealium';
import RouterLink from '../atoms/RouterLink/RouterLink';
export var CategoriesSiblings = function CategoriesSiblings(_ref) {
  var fields = _ref.fields,
    params = _ref.params;
  var sitecoreContext = React.useContext(SitecoreContextReactContext);
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  var pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  if (!fields) {
    console.warn('CategoriesSiblings component render skipped. No fields provided');
    if (pageEditing) {
      return /*#__PURE__*/React.createElement("div", {
        className: "no-data"
      }, " [CategoriesSiblings component is empty: please provide data source]");
    }
    return null;
  }
  var titleClickAnalytics = get(fields, 'data.titleClickAnalytics');
  var bannerClickAnalytics = get(fields, 'data.bannerClickAnalytics');
  var learnMoreAnalytics = get(fields, 'data.learnMoreAnalytics');
  var hasTitle = Boolean(get(fields, 'data.settings.title.value'));
  var hasItems = Boolean(get(fields, 'data.categories.parent.children.length'));
  var selfId = get(fields, 'data.categories.selfId', null);
  var items = hasItems ? fields.data.categories.parent.children : [];
  var numberOfCategoriesToRender = Number(get(fields, 'data.settings.numberOfCategories.value', 30));
  var randomOrder = Boolean(get(fields, 'data.settings.randomOrder.value'));
  var hasDescription = Boolean(get(fields, 'data.settings.description'));
  var ctaLabel = get(fields, 'data.settings.ctaLabel.value');
  var ctaLink = get(fields, 'data.settings.ctaLink.jss.value.href');
  var filteredItems = items.filter(function (i) {
    return i.headerImage && i.headerImage.src && i.id !== selfId;
  });
  /*eslint-disable */

  var _React$useState = React.useState([]),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    randomizedItems = _React$useState2[0],
    setRandomizedItems = _React$useState2[1];
  React.useEffect(function () {
    setRandomizedItems(randomOrder ? filteredItems.sort(function () {
      return filteredItems.length / 10 - Math.random();
    }) : filteredItems);
  }, []);
  /*eslint-disable */

  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    anchorUrlParameter: params['Anchor Url Parameter']
  }, /*#__PURE__*/React.createElement("div", {
    className: "subcategories subcategories--general"
  }, hasTitle && /*#__PURE__*/React.createElement(Text, {
    tag: "h3",
    className: "h3 sub__title",
    field: fields.data.settings.title
  }), hasDescription && /*#__PURE__*/React.createElement(Text, {
    tag: "p",
    className: "sub__desc body-small",
    field: fields.data.settings.description
  }), /*#__PURE__*/React.createElement("div", {
    className: "row sub-body"
  }, randomizedItems.slice(0, numberOfCategoriesToRender).map(function (item) {
    if (!item.pageName.value || item.pageName.value === '$name') {
      return null;
    }
    if (item.pageTitle.value) {
      return /*#__PURE__*/React.createElement("div", {
        key: item.id,
        className: "box-sub box-shadow ".concat(item.pageTitle.value !== undefined ? 'has-description' : '')
      }, /*#__PURE__*/React.createElement(RouterLink, {
        href: item.url,
        onClick: function onClick() {
          tealiumClickFunc(tealiumMergeClickData(bannerClickAnalytics, params), item.name);
        },
        title: item.pageName && item.pageName.value
      }, /*#__PURE__*/React.createElement(LazyPicture, {
        className: "box__picture",
        useEmptyPlaceholder: true
      }, /*#__PURE__*/React.createElement("source", {
        media: "(min-width: 1024px)",
        srcSet: injectImageResolution(item.headerImage.src, 1020, 765)
      }), /*#__PURE__*/React.createElement("source", {
        media: "(min-width: 768px)",
        srcSet: injectImageResolution(item.headerImage.src, 304, 304)
      }), /*#__PURE__*/React.createElement("img", {
        className: "box__img",
        src: injectImageResolution(item.headerImage.src, 152, 152),
        alt: item.headerImage.alt
      }))), /*#__PURE__*/React.createElement("div", {
        className: "box__title"
      }, item.pageName && item.pageName.value && /*#__PURE__*/React.createElement(RouterLink, {
        href: item.url,
        className: "link-text-decoration",
        onClick: function onClick() {
          tealiumClickFunc(tealiumMergeClickData(titleClickAnalytics, params), item.name);
        }
      }, /*#__PURE__*/React.createElement(Text, {
        tag: "h4",
        className: "h4 no-margin title__txt",
        field: item.pageName
      })), item.pageTitle && item.pageTitle.value && /*#__PURE__*/React.createElement(Text, {
        tag: "p",
        className: "body-small box-desc",
        field: item.pageTitle
      })));
    }
    return null;
  })), ctaLink && ctaLabel && /*#__PURE__*/React.createElement("div", {
    className: "txt-more"
  }, /*#__PURE__*/React.createElement(RouterLink, {
    className: "btn-tertiary",
    href: ctaLink,
    onClick: function onClick() {
      tealiumClickFunc(tealiumMergeClickData(learnMoreAnalytics, params));
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "btn-tertiary__text"
  }, ctaLabel), rtl ? /*#__PURE__*/React.createElement(ChevronLeft, {
    className: "btn-link__icon btn-link-icon"
  }) : /*#__PURE__*/React.createElement(ChevronRight, {
    className: "btn-link__icon btn-link-icon"
  })))));
};
var StyledWrapper = function StyledWrapper(_ref2) {
  var children = _ref2.children,
    rtl = _ref2.rtl,
    anchorUrlParameter = _ref2.anchorUrlParameter;
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    anchorUrlParameter: anchorUrlParameter,
    minHeight: true,
    className: "".concat(commonStyles, " ").concat(rtl ? rtlStyles : ltrStyles, " ").concat(commonStylesComponent)
  }, children);
};
var commonStylesComponent = "cvg25ae";
export default CategoriesSiblings;